import dynamic from "next/dynamic";
import React from "react";
import shallow from "zustand/shallow";
import Loading from "../components/loading";
import SEO from "../components/seo";
import { getPageTitle } from "../libs/seo/page-title";
import useAppStore from "../state/app-store";

const UserContainer = dynamic(() => import("../routes/user/container"), {
  ssr: false,
  loading: () => <Loading />,
});

const User: React.FC = () => {
  const setAppBarTitle = useAppStore((state) => state.setAppBarTitle, shallow);
  setAppBarTitle("Profil");

  return (
    <>
      <SEO
        title={getPageTitle("Profil")}
        description="Logga in eller skapa ett konto hos Reducera helt kostnadsfritt för att enkelt kunna synka dina spel mellan dina enheter, oavsett om du är på dator, mobil eller surfplatta."
      />
      <UserContainer />
    </>
  );
};

export default User;
